import clsx from 'clsx';
import styles from './IconButton.module.css';

function IconButton({ children, className, status, ...rest }) {
    return (
        <button
            {...rest}
            className={clsx(
                styles.bgYellow,
                styles.button,
                className,
                status === 'primary' && styles.primary,
                status === 'disable' && styles.disable,
            )}
        >
            {children}
        </button>
    );
}
export default IconButton;
